import { render } from "./sightHotel.vue?vue&type=template&id=d75d0ea4"
import script from "./sightHotel.vue?vue&type=script&lang=js"
export * from "./sightHotel.vue?vue&type=script&lang=js"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__